import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
const Analytics: React.FC = () => {
  // Mock data for charts
  const matchesOverTime = [{
    date: 'Mon',
    matches: 12
  }, {
    date: 'Tue',
    matches: 19
  }, {
    date: 'Wed',
    matches: 15
  }, {
    date: 'Thu',
    matches: 21
  }, {
    date: 'Fri',
    matches: 25
  }, {
    date: 'Sat',
    matches: 17
  }, {
    date: 'Sun',
    matches: 14
  }];
  const topProducts = [{
    name: 'Animal Shelter',
    value: 35
  }, {
    name: 'Food Bank',
    value: 25
  }, {
    name: 'Literacy Programs',
    value: 20
  }, {
    name: 'Other',
    value: 20
  }];
  const COLORS = ['#4ADE80', '#60A5FA', '#F472B6', '#94A3B8'];
  const topIntents = [{
    intent: 'I want to help animals in need',
    matches: 28
  }, {
    intent: 'Want to help feed the homeless',
    matches: 22
  }, {
    intent: 'How to help kids learn to read',
    matches: 18
  }, {
    intent: 'Want to help clean up beaches',
    matches: 15
  }, {
    intent: 'How to volunteer at hospitals',
    matches: 12
  }];
  return <div className="space-y-6" data-id="element-116">
      <div className="bg-gray-800 rounded-lg overflow-hidden" data-id="element-117">
        <div className="p-4 border-b border-gray-700" data-id="element-118">
          <h2 className="text-xl font-semibold" data-id="element-119">Matches Over Time</h2>
        </div>
        <div className="p-4 h-64" data-id="element-120">
          <ResponsiveContainer width="100%" height="100%" data-id="element-121">
            <BarChart data={matchesOverTime} data-id="element-122">
              <CartesianGrid strokeDasharray="3 3" stroke="#374151" data-id="element-123" />
              <XAxis dataKey="date" stroke="#9CA3AF" data-id="element-124" />
              <YAxis stroke="#9CA3AF" data-id="element-125" />
              <Tooltip contentStyle={{
              backgroundColor: '#1F2937',
              borderColor: '#374151'
            }} itemStyle={{
              color: '#E5E7EB'
            }} labelStyle={{
              color: '#E5E7EB'
            }} data-id="element-126" />
              <Bar dataKey="matches" fill="#4ADE80" data-id="element-127" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-128">
        <div className="bg-gray-800 rounded-lg overflow-hidden" data-id="element-129">
          <div className="p-4 border-b border-gray-700" data-id="element-130">
            <h2 className="text-xl font-semibold" data-id="element-131">Top Volunteer Activities</h2>
          </div>
          <div className="p-4 h-64 flex items-center justify-center" data-id="element-132">
            <ResponsiveContainer width="100%" height="100%" data-id="element-133">
              <PieChart data-id="element-134">
                <Pie data={topProducts} cx="50%" cy="50%" labelLine={false} outerRadius={80} fill="#8884d8" dataKey="value" label={({
                name,
                percent
              }) => `${name} ${(percent * 100).toFixed(0)}%`} data-id="element-135">
                  {topProducts.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-136" />)}
                </Pie>
                <Tooltip contentStyle={{
                backgroundColor: '#1F2937',
                borderColor: '#374151'
              }} itemStyle={{
                color: '#E5E7EB'
              }} formatter={value => [`${value} matches`, 'Matches']} data-id="element-137" />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="bg-gray-800 rounded-lg overflow-hidden" data-id="element-138">
          <div className="p-4 border-b border-gray-700" data-id="element-139">
            <h2 className="text-xl font-semibold" data-id="element-140">
              Top Performing Intent Phrases
            </h2>
          </div>
          <div className="p-4" data-id="element-141">
            <table className="w-full text-sm" data-id="element-142">
              <thead className="text-left text-gray-400" data-id="element-143">
                <tr data-id="element-144">
                  <th className="pb-2 font-normal" data-id="element-145">Intent Phrase</th>
                  <th className="pb-2 font-normal text-right" data-id="element-146">Matches</th>
                </tr>
              </thead>
              <tbody data-id="element-147">
                {topIntents.map((item, index) => <tr key={index} className="border-t border-gray-700" data-id="element-148">
                    <td className="py-3 truncate max-w-[200px]" data-id="element-149">
                      "{item.intent}"
                    </td>
                    <td className="py-3 text-right" data-id="element-150">
                      <span className="bg-green-900 bg-opacity-50 text-green-400 px-2 py-1 rounded" data-id="element-151">
                        {item.matches}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
};
export default Analytics;